import { useQuery } from "@tanstack/react-query";
import api from "../../utils/api";
import { useGetApplicantDetailsQuery } from "./useGetApplicantDetailsQuery";

interface UseGetRequiredDocumentsQueryProps {
  programTypeId?: number;
}

const getRequiredDocuments = async (programTypeId: number) => {
  return (
    await api.get(
      `/AdmissionDocument/Student/GetRequiredDocuments?programTypeId=${programTypeId}`,
    )
  ).data as RequiredDocumentsResponse;
};

export const useGetRequiredDocumentsQuery = (
  props?: UseGetRequiredDocumentsQueryProps,
) => {
  const { applicantDetails } = useGetApplicantDetailsQuery();
  const programTypeId = props?.programTypeId ?? applicantDetails?.programTypeId;

  const query = useQuery({
    queryKey: ["get-required-documents", programTypeId],
    queryFn: () => getRequiredDocuments(programTypeId as number),
    enabled: !!programTypeId,
  });

  return {
    ...query,
    documents: query.data?.data as RequiredDocument[] | undefined,
  };
};

export default useGetRequiredDocumentsQuery;
